import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconMenuDots = ({
  width = '24px',
  height = '24px',
  fill = '#000',
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5" cy="12" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="19" cy="12" r="2" />
    </svg>
  )
}

export default IconMenuDots